"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUpgrades = void 0;
const standardize_package_name_1 = require("../../../standardize-package-name");
const validate_required_data_1 = require("../../validate-required-data");
function generateUpgrades(entity) {
    const { remediation } = (0, validate_required_data_1.validateRequiredData)(entity);
    const { pin: pins } = remediation;
    const upgrades = [];
    for (const pkgAtVersion of Object.keys(pins)) {
        const pin = pins[pkgAtVersion];
        const newVersion = pin.upgradeTo.split('@')[1];
        const [pkgName] = pkgAtVersion.split('@');
        upgrades.push(`${(0, standardize_package_name_1.standardizePackageName)(pkgName)}==${newVersion}`);
    }
    return { upgrades };
}
exports.generateUpgrades = generateUpgrades;
//# sourceMappingURL=generate-upgrades.js.map